/**************************************************
 * Nombre:       Formulario_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {TitleOutlined, Flag, PhoneAndroidOutlined, TextFormatOutlined,ShortTextOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSMAYORISTAS, ESTADOSPRODUCTO} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Anuncios = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={53} ancho={123} {...props}  />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen de 1230px por 530px de menos de 500K de peso</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={ShortTextOutlined} nombre={'Texto pequeño'}
                                  dato={'subTituloUno'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo primera parte'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TextFormatOutlined} nombre={'Titulo segunda parte RESALTADO'}
                                  dato={'subTituloDos'} {...props}

                    />

                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'}
                                  dato={'descripcion'} {...props}

                    />

                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Texto Bonton'} dato={'textoBoton'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Link Bonton'} dato={'link'} {...props}

                    />
                </Grid>




            </Grid>

        </form>

    )

}
export default Formulario_Anuncios